import { buildSlice, CommonState } from '~libs/reduxUtils';
import { Client } from '~weekly-planner/lib/common';

import { clientsApi, typePrefix } from '~weekly-planner/actions/clients';

interface State extends CommonState<Client> {
  simulated: Client[];
  loadingRows: Record<string, boolean>;
}

const initialState: State = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  simulated: [],
  loadingRows: {},
};

const slice = buildSlice<State, Client>(typePrefix, initialState, {
  rtkQueryBridges: [
    {
      endpoint: clientsApi.endpoints.getClients,
      mode: 'list',
      selectRows: (payload: Client[]) => payload,
    },
  ],
  customActions: {
    clearSimulated(state) {
      state.simulated = [];
      state.loadingRows = {};
    },
  },
});

export const { clear, clearSimulated, updateParams } = slice.actions;
export default slice.reducer;
